<p-toast position="top-right"></p-toast>
<div class="conversation-container">
  <div class="conversation-left-contianer">

    <!-- Loading -->
    <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center">
      <p>Loading conversation...</p>
    </div>

    <!-- Chat Messages -->
    <div class="chat-messages" *ngIf="!isLoading">

      <ng-container *ngIf="conversations && conversations.length > 0; else noData">

      <!-- Check if schedules exist -->
      <ng-container *ngIf="contactInfo?.schedules && contactInfo.schedules.length > 0; else noSchedules">
        <!-- Loop through schedules -->
        <div *ngFor="let schedule of contactInfo.schedules; let i = index" class="schedule-section mt-4 mb-4">

          <!-- Schedule Header -->
          <div class="cancel-separator mb-3" *ngIf="schedule.scheduleNumber > 1">
            <span>
              <i class="pi pi-calendar"></i>
              {{ 'Reschedule by '+ contactInfo[schedule.scheduleNumber - 2]?.performerName }}
            </span>
          </div>

          <!-- Messages for this schedule -->
          <div *ngFor="let conversation of conversations | filterBySchedule:schedule.scheduleNumber; let j = index">
            <!-- Cancelled Conversation -->
            <div *ngIf="conversation.conversationType === 'cancelled'" class="cancel-separator mt-4 mb-4">
              <span>
                <i class="pi pi-times"></i>
                Tour cancelled by {{ contactInfo?.performerName }}
              </span>
            </div>

            <!-- Reminders Conversation -->
            <div *ngIf="conversation.conversationType === 'reminder'+ReminderCount.FIRST"
              class="cancel-separator mt-4 mb-4">
              <span>
                <i class="pi pi-calendar"></i>
                Reminder {{ReminderCount.FIRST}} - After {{ReminderHours.ONE}} Hour by System
              </span>
            </div>
            <div *ngIf="conversation.conversationType === 'reminder'+ReminderCount.SECOND"
              class="cancel-separator mt-4 mb-4">
              <span>
                <i class="pi pi-calendar"></i>
                Reminder {{ReminderCount.SECOND}} - After {{ReminderHours.FIVE}} Hours by System
              </span>
            </div>
            <div *ngIf="conversation.conversationType === 'reminder'+ReminderCount.THIRD"
              class="cancel-separator mt-4 mb-4">
              <span>
                <i class="pi pi-calendar"></i>
                Reminder {{ReminderCount.THIRD}} - After {{ReminderHours.EIGHTEEN}} Hours by System
              </span>
            </div>

            <!-- System Messages -->
            <div *ngIf="conversation.fromRole === ConversationRole.SYSTEM || conversation.fromRole === ConversationRole.ADMIN" class="bot-message mt-3">
              <div class="w-100 d-flex flex-column align-items-end">
                <div class="message-container d-flex flex-column align-items-end gap-1 justify-content-end">
                  <h4 class="mb-0">{{ conversation.fromRole === ConversationRole.ADMIN ? 'Landlord' : (conversation.isTextbot ? 'Petrie-TextBot' : 'Petrie') }}</h4>
                  <div class="d-flex gap-2 align-items-center">
                      <span>{{ conversation.createdAt | timezoneDate:contactInfo?.property_id?.timezone:'date' }}</span>
                      <span>{{ conversation.createdAt | timezoneDate:contactInfo?.property_id?.timezone:'time' }}</span>
                  </div>
                  <div class="d-flex flex-row align-items-center gap-4">
                    <div class="message" [ngClass]="{'landlord-message': conversation.fromRole === ConversationRole.ADMIN}">{{ conversation.message }}</div>

                  </div>
                </div>
              </div>
            </div>

            <!-- Resident & Visitor Messages -->
            <ng-container *ngIf="conversation.fromRole !== ConversationRole.SYSTEM && conversation.fromRole !== ConversationRole.ADMIN">
              <div class="user-message d-flex flex-row align-items-center mt-3 flex-column" [ngClass]="{
                     'justify-content-end': !isSystemConversation && conversation.fromRole === ConversationRole.RESIDENT,
                     'justify-content-start': isSystemConversation || conversation.fromRole === ConversationRole.VISITOR
                   }">
                <div class="d-flex flex-column w-100" [ngClass]="{
                       'align-items-end': !isSystemConversation && conversation.fromRole === ConversationRole.RESIDENT,
                       'align-items-start': isSystemConversation || conversation.fromRole === ConversationRole.VISITOR
                     }">
                  <div class="message-container">
                    <div class="d-flex flex-column gap-1" [ngClass]="{
                           'flex-row-reverse': !isSystemConversation && conversation.fromRole === ConversationRole.RESIDENT,
                           'flex-row': isSystemConversation || conversation.fromRole === ConversationRole.VISITOR
                         }">
                      
                        <h4 class="mb-0">
                          {{ conversation.fromRole === ConversationRole.RESIDENT ? (schedule.acceptedBy?.user_name ||
                          'To Be Assigned') : contactInfo?.customer_name }}
                        </h4>
                        <div class="d-flex gap-2 align-items-center">
                          <span>{{ conversation.createdAt | timezoneDate:contactInfo?.property_id?.timezone:'date'
                            }}</span>
                          <span>{{ conversation.createdAt | timezoneDate:contactInfo?.property_id?.timezone:'time'
                            }}</span>
                        </div>
                        <div class="message" [ngClass]="{
                          'resident': conversation.fromRole === ConversationRole.RESIDENT,
                          'visitor': conversation.fromRole === ConversationRole.VISITOR
                        }">
                        
                          {{ conversation.message }}
                        </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="!isSystemConversation && isFirstResidentMessage(j, conversation)"
                  class="resident-added text-center mt-3">
                  + {{ schedule.acceptedBy?.user_name || 'To Be Assigned' }} added
                </div>
              </div>
            </ng-container>

          </div>
        </div>
      </ng-container>

      <!-- Fallback for old tours without schedules -->
      <ng-template #noSchedules>
        <div class="schedule-section mt-4 mb-4">
          <!-- <div class="schedule-separator mb-3">
            <span>
              <i class="pi pi-calendar"></i>
              Original Schedule - {{ contactInfo?.date + ' ' + contactInfo?.time | timezoneDate: contactInfo?.property_id?.timezone:'datetime' }}
              (Assigned to: {{ contactInfo?.user_name || 'To Be Assigned' }})
            </span>
          </div> -->

          <div *ngFor="let conversation of conversations; let j = index">

            <!-- Cancelled Conversation -->
            <div *ngIf="conversation.conversationType === 'cancelled'" class="cancel-separator mt-4 mb-4">
              <span>
                <i class="pi pi-times"></i>
                Tour cancelled by {{ contactInfo?.performerName }}
              </span>
            </div>

            <!-- Reminders Conversation -->
            <div *ngIf="conversation.conversationType === 'reminder'+ReminderCount.FIRST"
              class="cancel-separator mt-4 mb-4">
              <span>
                <i class="pi pi-calendar"></i>
                Reminder {{ReminderCount.FIRST}} - After {{ReminderHours.ONE}} Hour by System
              </span>
            </div>
            <div *ngIf="conversation.conversationType === 'reminder'+ReminderCount.SECOND"
              class="cancel-separator mt-4 mb-4">
              <span>
                <i class="pi pi-calendar"></i>
                Reminder {{ReminderCount.SECOND}} - After {{ReminderHours.FIVE}} Hours by System
              </span>
            </div>
            <div *ngIf="conversation.conversationType === 'reminder'+ReminderCount.THIRD"
              class="cancel-separator mt-4 mb-4">
              <span>
                <i class="pi pi-calendar"></i>
                Reminder {{ReminderCount.THIRD}} - After {{ReminderHours.EIGHTEEN}} Hours by System
              </span>
            </div>

            <!-- System Messages -->
            <div *ngIf="conversation.fromRole === ConversationRole.SYSTEM || conversation.fromRole === ConversationRole.ADMIN" class="bot-message mt-3">
              <div class="w-100 d-flex flex-column align-items-end">
                <div class="message-container d-flex flex-column align-items-end gap-1 justify-content-end">
                  <h4 class="mb-0">{{ conversation.fromRole === ConversationRole.ADMIN ? 'Landlord' : (conversation.isTextbot ? 'Petrie-TextBot' : 'Petrie') }}</h4>
                  <div class="d-flex gap-2 align-items-center">
                      <span>{{ conversation.createdAt | timezoneDate:contactInfo?.property_id?.timezone:'date' }}</span>
                      <span>{{ conversation.createdAt | timezoneDate:contactInfo?.property_id?.timezone:'time' }}</span>
                    </div>
                  <div class="d-flex flex-row align-items-center gap-4">
                    <div class="message" [ngClass]="{'landlord-message': conversation.fromRole === ConversationRole.ADMIN}">{{ conversation.message }}</div>                   
                  </div>
                </div>
              </div>
            </div>

            <!-- Resident & Visitor Messages -->
            <ng-container *ngIf="conversation.fromRole !== ConversationRole.SYSTEM && conversation.fromRole !== ConversationRole.ADMIN">
              <div class="user-message d-flex flex-row align-items-center mt-3 flex-column" [ngClass]="{
                     'justify-content-end': !isSystemConversation && conversation.fromRole === ConversationRole.RESIDENT,
                     'justify-content-start': isSystemConversation || conversation.fromRole === ConversationRole.VISITOR
                   }">
                <div class="d-flex flex-column w-100" [ngClass]="{
                       'align-items-end': !isSystemConversation && conversation.fromRole === ConversationRole.RESIDENT,
                       'align-items-start': isSystemConversation || conversation.fromRole === ConversationRole.VISITOR
                     }">
                  <div class="message-container">
                    <div class="d-flex flex-column gap-1" [ngClass]="{
                           'flex-row-reverse': !isSystemConversation && conversation.fromRole === ConversationRole.RESIDENT,
                           'flex-row': isSystemConversation || conversation.fromRole === ConversationRole.VISITOR
                         }">
                     
                        <h4 class="mb-0">
                          {{ conversation.fromRole === ConversationRole.RESIDENT ? (contactInfo?.user_name || 'To Be
                          Assigned') : contactInfo?.customer_name }}
                        </h4>
                        <div class="d-flex gap-2 align-items-center">
                          <span>{{ conversation.createdAt | timezoneDate:contactInfo?.property_id?.timezone:'date'
                            }}</span>
                          <span>{{ conversation.createdAt | timezoneDate:contactInfo?.property_id?.timezone:'time'
                            }}</span>
                        </div>
                        <div class="message" [ngClass]="{
                          'resident': conversation.fromRole === ConversationRole.RESIDENT,
                          'visitor': conversation.fromRole === ConversationRole.VISITOR
                        }">
                          {{ conversation.message }}
                        </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="!isSystemConversation && isFirstResidentMessage(j, conversation)"
                  class="resident-added text-center mt-3">
                  + {{ contactInfo?.user_name || 'To Be Assigned' }} added
                </div>
              </div>
            </ng-container>

          </div>
        </div>
      </ng-template>

      </ng-container>

    <ng-template #noData>
      <div class="alert alert-danger text-center align-items-center justify-content-center">
        No conversation yet!
      </div>
    </ng-template>

    <div #scrollAnchor></div>

    </div>

    <!-- Sticky Chat Input -->
<div *ngIf="activeLink === ConversationRole.VISITOR" class="chat-input-wrapper">
  <div class="chat-input-bar d-flex flex-column gap-2">

    <textarea pInputTextarea [(ngModel)]="newMessage" placeholder="Type a message..."
      class="flex-grow-1 w-100 chat-textarea" [maxlength]="1000" [disabled]="isSending" rows="4">
    </textarea>

    <div class="d-flex justify-content-between align-items-center">
      <small [ngClass]="newMessage.length >= 1000 ? 'text-danger' : 'text-muted'">
        {{ newMessage.length }}/1000 characters
      </small>
      <p-button type="button" class="primary-btn" label="Send" [loading]="isSending"
        (click)="sendAdminMessageToVisitor()"></p-button>
    </div>

  </div>
</div>

  </div>
  <div class="conversation-right-contianer">
    <div class="chat-header">
      <h2>Tour</h2>
      <button pButton class="bg-transparent border-0" (click)="closeChat()">
        <i class="pi pi-times text-white bg-dark rounded-circle p-1"></i>
      </button>
    </div>
    <div class="row pb-4">
      <div class="col-lg-12 mt-3">
        <div class="form-group">
          <label for="name">Name</label>
          <input type="text" pInputText value="{{contactInfo?.customer_name}}" />
        </div>
      </div>
      <div class="col-lg-12">
        <div class="form-group">
          <label for="name">Email</label>
          <input type="mail" pInputText value="{{contactInfo?.customer_email}}" disabled />
        </div>
      </div>
      <div class="col-lg-12">
        <div class="form-group">
          <label for="name">Phone</label>
          <input type="text" pInputText value="{{contactInfo?.phone_number | phoneFormat:'US'}}" disabled />
        </div>
      </div>
      <div class="col-lg-12">
        <div class="form-group">
          <label for="name">Resident</label>
          <input type="text" pInputText value="{{contactInfo.user_name || 'To Be Assigned'}}" disabled />
        </div>
      </div>
      <div class="col-lg-12">
        <div class="form-group">
          <label for="name">Date</label>
          <input type="text" pInputText
            value="{{contactInfo?.date+' '+contactInfo?.time | timezoneDate:contactInfo?.property_id?.timezone:'datetime'}}"
            disabled />
        </div>
      </div>
      <div class="col-lg-12">
        <div class="form-group">
          <label for="name">Lockbox Code</label>
          <input type="text" pInputText value="{{ contactInfo?.lockbox_code ?? 'Not Generated Yet' }}" disabled />
        </div>
      </div>
      <div class="col-lg-12">
        <div class="form-group">
          <label for="name">Lead Source</label>
          <input type="text" pInputText value="{{contactInfo?.external_lead_source || LeadSource.PETRIE }}" disabled />
        </div>
      </div>      

      <!-- Tour Status Banner (bot-initiated cancellation) -->
      <div class="col-lg-12 mt-3" *ngIf="contactInfo?.tourStatus === 'cancelled'">
        <div class="tour-status-banner cancelled-banner">
          <small class="status-label">TOUR STATUS</small>
          <strong class="status-title text-danger">Cancelled by Lead</strong>
          <p class="status-desc mb-0">Original tour was automatically cancelled after the lead sent a cancellation message.</p>
        </div>
      </div>

      <!-- Reschedule Status (lead selected a slot, pending admin confirmation) -->
      <div class="col-lg-12 mt-2" *ngIf="contactInfo?.tourStatus === 'cancelled' && contactInfo?.rescheduleRequest">
        <div class="tour-status-banner reschedule-pending-banner">
          <small class="status-label">RESCHEDULE STATUS</small>
          <strong class="status-title">New Time Selected</strong>
          <p class="status-desc mb-0">Lead selected {{contactInfo.rescheduleRequest?.date}} at {{contactInfo.rescheduleRequest?.time}}. Resident assignment needed.</p>
        </div>
      </div>

      <!-- New Proposed Tour field -->
      <div class="col-lg-12" *ngIf="contactInfo?.tourStatus === 'cancelled' && contactInfo?.rescheduleRequest">
        <div class="form-group">
          <label>New Proposed Tour</label>
          <input type="text" pInputText value="{{contactInfo.rescheduleRequest?.date}} {{contactInfo.rescheduleRequest?.time}}" disabled />
        </div>
      </div>

      <!-- Confirm New Tour button -->
      <div class="col-lg-12 mt-3" *ngIf="contactInfo?.tourStatus === 'cancelled' && contactInfo?.rescheduleRequest">
        <p-button type="button" class="primary-btn w-100" styleClass="w-100" label="Confirm New Tour"
          [loading]="isConfirmingReschedule"
          (click)="confirmReschedule()"></p-button>
      </div>

      <!-- Send More Times button -->
      <div class="col-lg-12 mt-2" *ngIf="contactInfo?.tourStatus === 'cancelled'">
        <p-button type="button" styleClass="w-100" label="Send More Times"
          class="w-100" [style]="{'width':'100%'}"
          [outlined]="true"
          [loading]="isSendingMoreTimes"
          (click)="sendMoreTimes()"></p-button>
      </div>

      <!-- Conversation screen links -->
      <div class="col-lg-12">
        <div class="form-group mt-4">
          <label for="name">Petrie/Resident Messaging</label>
          <a href="javascript:void(0)" [class.disabled]="activeLink !== ConversationRole.SYSTEM"
            (click)="activeLink = ConversationRole.SYSTEM; loadConversation(ConversationRole.SYSTEM, ConversationRole.RESIDENT)">{{property}}/messaging/tourId{{contactInfo?.tour_id
            ?? ''}}</a>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="form-group">
          <label for="name">Petrie/Resident/Lead Messaging</label>
          <a href="javascript:void(0)" [class.disabled]="activeLink !== ConversationRole.RESIDENT"
            (click)="activeLink = ConversationRole.RESIDENT; loadConversation(ConversationRole.RESIDENT, ConversationRole.VISITOR)">{{property}}/messaging/tourId{{contactInfo?.tour_id
            ?? ''}}</a>
        </div>
      </div>
      <div class="col-lg-12" *ngIf="userType === 'landlord'">
        <div class="form-group">
          <label for="name">Petrie/Lead Messaging</label>
          <a href="javascript:void(0)" [class.disabled]="activeLink !== ConversationRole.VISITOR"
            (click)="activeLink = ConversationRole.VISITOR; loadConversation(ConversationRole.SYSTEM, ConversationRole.VISITOR)">{{property}}/messaging/tourId{{contactInfo?.tour_id
            ?? ''}}</a>
        </div>
      </div>


      <!-- Tags Section -->
      <div class="col-lg-12">
        <div class="form-group theme-border-bg">
          <label class="tags-label">Tags</label>

          <!-- Selected tag chips -->
          <div class="chips-wrapper" *ngIf="tags.length > 0">
            <span *ngFor="let tag of tags; let i = index"
                  class="tag-chip"
                  [style.background-color]="tag.color">
              {{ tag.name }}
              <button type="button" class="remove-btn" (click)="removeTag(i)" [attr.aria-label]="'Remove ' + tag.name">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
                </svg>
              </button>
            </span>
          </div>

          <!-- Dropdown trigger -->
          <div class="tag-trigger-row">
            <div class="tag-select-wrapper" #tagSelectWrapper>
              <button type="button" class="tag-select-btn" (click)="toggleTagDropdown()">
                <span>Select or create tags…</span>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
                  <path d="m7 15 5 5 5-5"/><path d="m7 9 5-5 5 5"/>
                </svg>
              </button>

              <!-- Dropdown -->
              <div class="tag-dropdown" *ngIf="showTagDropdown">

                <!-- Search -->
                <input type="text" class="tag-search" placeholder="Search tags…"
                       [(ngModel)]="tagSearch" (ngModelChange)="filterGlobalTags()" />

                <!-- Duplicate warning -->
                <div *ngIf="duplicateTagWarning" class="tag-duplicate-warning">
                  ⚠ {{ duplicateTagWarning }}
                </div>

                <!-- Tag options list -->
                <div class="tag-options-list">
                  <div *ngFor="let tName of filteredGlobalTags"
                       class="tag-option"
                       [class.tag-option--highlight]="highlightedTag?.toLowerCase() === tName.name.toLowerCase()"
                       (click)="toggleTag(tName.name)">
                    <span class="tag-dot" [style.background-color]="getTagDotColor(tName.name)"></span>
                    <span class="tag-option-name">{{ tName.name }}</span>
                    <span *ngIf="isTagSelected(tName.name)" class="tag-check">✓</span>
                  </div>
                  <div *ngIf="filteredGlobalTags.length === 0" class="tag-empty">
                    No tags found
                  </div>
                </div>

                <div class="tag-divider"></div>

                <!-- Create new trigger -->
                <div *ngIf="!showCreateForm" class="create-new" (click)="openCreateForm()">
                  + &nbsp;Create new tag
                </div>

                <!-- Create new inline form -->
                <div *ngIf="showCreateForm" class="create-form">
                  <div class="create-form-inputs">
                    <input type="text" class="create-name-input" placeholder="Tag name…"
                           [(ngModel)]="newTagName" [maxlength]="30"
                           (ngModelChange)="duplicateTagWarning = ''" />
                    <input type="color" [(ngModel)]="tagColor" class="tag-color-picker" title="Tag color" />
                  </div>
                  <small [ngClass]="newTagName.length >= 30 ? 'text-danger' : 'text-muted'">
                    {{ newTagName.length }}/30
                  </small>
                  <div class="create-form-actions">
                    <p-button type="button" class="primary-btn" label="Add" (click)="submitNewTag()"></p-button>
                    <button type="button" class="cancel-btn" (click)="showCreateForm = false">Cancel</button>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="col-lg-12 mt-2">
        <div class="form-group">
          <label class="text-primry">Internal Notes</label>
          <textarea rows="5" pInputTextarea class="w-100" [(ngModel)]="internalNote"
            placeholder="Add internal notes about this lead..." (ngModelChange)="updateCharCount()"
            [maxlength]="maxChars"></textarea>
          <small [ngClass]="internalNote.length > maxChars ? 'text-danger' : 'text-muted'">
            {{ charCount }}/{{ maxChars }} characters
          </small>
        </div>
      </div>
      <div class="col-lg-12 mt-3">
        <p-button type="button" class="primary-btn w-100" styleClass="w-100" label="Save"
          (click)="addNote()"></p-button>
      </div>
      <div class="mt-2 gap-2 d-flex gap-2 flex-wrap">
        <ul class="note-list">
          <li *ngFor="let note of internalNotes; let i = index" class="d-flex gap-2 gray-bg-bordered"
            [class.active-note]="note.latest">
            <i class="pi pi-times ml-1 cursor-pointer" (click)="removeNote(note)"></i>
            <p class="cursor-pointer" (click)="selectNote(note)">{{ note.text }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>